import type {
  AppPageStickyOptions,
  PricingPlansSectionOptions,
} from '@wix/app-market-components';

export interface AppPageOptions extends AppModalDisplayOptions {
  showRecommendedForYou?: boolean;
  showHeaderLinks?: boolean;
  stickyHeaderOptions?: AppPageStickyOptions;
  pricingOptions?: PricingPlansSectionOptions;
  mode?: 'test' | 'unlisted';
  showFeaturedIn?: boolean;
  disabledLinks?: AppPageLink[];
}

export enum AppPageLink {
  'COMPANY_PAGE' = 'COMPANY_PAGE',
}

export interface AppModalDisplayOptions {
  showCtas?: boolean;
  showRating?: boolean;
  showHeader?: boolean;
  showReviews?: boolean;
  skin?: 'lean' | 'slim' | 'normal';
  showPermissions?: boolean;
  showPricingPlans?: boolean;
  showStickyHeader?: boolean;
  showModalLayout?: boolean;
  showTermsAndConditions?: boolean;
}

export interface AppFetchOptions {
  fetchPermissions?: boolean;
  fetchManagedApps?: boolean;
  fetchPricingPlans?: boolean;
}
